import React from 'react';
import Bg from '../../assets/images/married-1.svg';
import {
  ContactLink,
  Description,
  ErrorInfoWrapper,
  Title
} from 'components/full-page-error/style';
import { NoPropertiesImageWrapper, StyledNoPropertyResults } from './style';
import { segment } from '@leadhome/utils';
import { whatsappUrl } from '@oxygen/ab/WhatsApp';

function NoPropertyResults() {
  return (
    <StyledNoPropertyResults>
      <NoPropertiesImageWrapper>
        <Bg />
      </NoPropertiesImageWrapper>
      <ErrorInfoWrapper>
        <Title>We couldn’t find any properties matching your search</Title>
        <Description>
          Please update your search criteria,{' '}
          <ContactLink
            target='_blank'
            href={whatsappUrl}
            onClick={() =>
              segment.track('PropertySearch: NoSearchResultsWhatsApp')
            }
          >
            chat with us
          </ContactLink>{' '}
          or{' '}
          <ContactLink
            href='/contact-us'
            onClick={() =>
              segment.track('PropertySearch: NoSearchResultsSupport')
            }
          >
            send us an email.
          </ContactLink>
        </Description>
      </ErrorInfoWrapper>
    </StyledNoPropertyResults>
  );
}

export default React.memo(NoPropertyResults);
